import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { writeAuthReturnLocation } from "../../domain/auth/authReturnLocation";
import TRAIcon from "../icons/TRAIcon";
import { resolveActiveNavId, resolvePlatformNavItems } from "./platformNavItems";
import { navItemLabel, useCompactNavLabel } from "./useCompactNavLabel";
import styles from "./shell.module.css";
import { cn } from "../utils/cn";

/** Mobile platform bottom navigation (Stitch 5-tab). Distinct from session MatchApplication tabs. */
export default function BottomNavigation({ items, className }) {
  const { pathname } = useLocation();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const compact = useCompactNavLabel();
  const navItems = items ?? resolvePlatformNavItems(isAuthenticated);
  const activeId = resolveActiveNavId(pathname);

  return (
    <nav className={cn(styles.bottomNav, className)} aria-label="Primary mobile">
      {navItems.map((item) => {
        const active = item.id === activeId;
        const signIn = item.to === "/sign-in";
        return (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.to === "/"}
            state={signIn ? { from: location } : undefined}
            className={cn(styles.bottomNavLink, active && styles.bottomNavLinkActive)}
            aria-current={active ? "page" : undefined}
            aria-label={item.label}
            onClick={
              signIn
                ? () => {
                    writeAuthReturnLocation(location);
                  }
                : undefined
            }
          >
            <TRAIcon name={item.icon} size="md" />
            <span>{navItemLabel(item, compact)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
